import React from "react";

const FicheTag = ({ tag }) => {
  return <li className="tag__list">{tag}</li>;
};

export default FicheTag;
